/**
 * Mock data for internships in the SCAD system
 * Centralized data source to be used across all components
 */

export const internshipsData = [
  {
    id: 101,
    title: 'Software Engineering Intern',
    company: 'TechNova',
    companyId: 1,
    logo: 'https://cdn-icons-png.flaticon.com/512/5968/5968705.png',
    location: 'Cairo, Egypt (Hybrid)',
    duration: '3 months',
    paid: true,
    salary: '5000-7000 EGP/month',
    deadline: '2025-06-30',
    postedDate: '2025-05-01',
    description: 'Join our engineering team to develop cutting-edge software solutions using modern technologies. You will work on real projects under the guidance of experienced mentors.',
    requirements: 'Computer Science or related field, Knowledge of JavaScript/TypeScript, Experience with React is a plus',
    responsibilities: 'Develop and maintain web applications, Write clean and efficient code, Collaborate with the development team, Participate in code reviews',
    status: 'Open',
    applicationsCount: 12,
    industry: 'Software Development',
    size: '500-1000 employees',
    match: 95,
    interests: ['Artificial Intelligence', 'Machine Learning', 'Cloud Computing', 'Web Development'],
    recommendations: [
      {
        studentName: 'Ahmed Hassan',
        rating: 4.8,
        comment: 'Great work environment with challenging projects. Learned a lot during my internship.'
      }
    ]
  },
  {
    id: 102,
    title: 'Data Science Intern',
    company: 'GlobalFinance',
    companyId: 2,
    logo: 'https://cdn-icons-png.flaticon.com/512/2830/2830284.png',
    location: 'Cairo, Egypt (On-site)',
    duration: '6 months',
    paid: true,
    salary: '6000-8000 EGP/month',
    deadline: '2025-06-15',
    postedDate: '2025-04-25',
    description: 'Work with our data science team to analyze financial data and develop predictive models. This internship offers hands-on experience with real-world financial datasets.',
    requirements: 'Statistics, Mathematics, or Computer Science background, Knowledge of Python, Experience with data analysis libraries (Pandas, NumPy), Basic understanding of machine learning concepts',
    responsibilities: 'Clean and preprocess financial data, Develop and implement statistical models, Create visualizations to communicate findings, Collaborate with the analytics team',
    status: 'Open',
    applicationsCount: 18,
    industry: 'Financial Services',
    size: '1000+ employees',
    match: 85,
    interests: ['Financial Technology', 'Data Analysis', 'Cybersecurity', 'Blockchain'],
    recommendations: [
      {
        studentName: 'Omar Mahmoud',
        rating: 4.2,
        comment: 'Gained valuable experience in fintech and data analysis. The team was very supportive.'
      }
    ]
  },
  {
    id: 103,
    title: 'Environmental Engineer Intern',
    company: 'EcoSolutions',
    companyId: 3,
    logo: 'https://cdn-icons-png.flaticon.com/512/6001/6001368.png',
    location: 'Alexandria, Egypt (On-site)',
    duration: '3 months',
    paid: false,
    deadline: '2025-07-10',
    postedDate: '2025-05-05',
    description: 'Join our team working on sustainable technology solutions for environmental challenges. You will assist in designing and implementing eco-friendly systems.',
    requirements: 'Environmental Engineering or related field, Basic knowledge of sustainability principles, Interest in clean technology',
    responsibilities: 'Assist in designing sustainable systems, Collect and analyze environmental data, Participate in field tests, Contribute to research on new eco-friendly technologies',
    status: 'Open',
    applicationsCount: 7,
    industry: 'Environmental Technology',
    size: '100-500 employees',
    match: 78,
    interests: ['Sustainability', 'Clean Energy', 'Environmental Engineering', 'IoT'],
    recommendations: [
      {
        studentName: 'Laila Ibrahim',
        rating: 4.7,
        comment: 'Amazing company culture focused on sustainability. Great projects with real-world impact.'
      }
    ]
  },
  {
    id: 104,
    title: 'Healthcare Software Developer Intern',
    company: 'HealthTech',
    companyId: 4,
    logo: 'https://cdn-icons-png.flaticon.com/512/5360/5360804.png',
    location: 'Cairo, Egypt (Remote)',
    duration: '4 months',
    paid: true,
    salary: '5500-7500 EGP/month',
    deadline: '2025-06-25',
    postedDate: '2025-04-30',
    description: 'Develop software solutions for healthcare applications. You will work on projects that directly impact patient care and medical research.',
    requirements: 'Computer Science or related field, Experience with at least one programming language, Interest in healthcare technology',
    responsibilities: 'Develop and test healthcare software applications, Implement features according to specifications, Debug and fix issues, Collaborate with the development and medical teams',
    status: 'Open',
    applicationsCount: 15,
    industry: 'Healthcare Technology',
    size: '500-1000 employees',
    match: 92,
    interests: ['Medical Informatics', 'Bioinformatics', 'Mobile Health', 'AI in Healthcare'],
    recommendations: [
      {
        studentName: 'Nour Hassan',
        rating: 4.9,
        comment: 'Exceptional internship experience working on AI applications in healthcare. Highly recommended!'
      }
    ]
  },
  {
    id: 105,
    title: 'UI/UX Design Intern',
    company: 'MediaWorks',
    companyId: 5,
    logo: 'https://cdn-icons-png.flaticon.com/512/5968/5968525.png',
    location: 'Giza, Egypt (Hybrid)',
    duration: '3 months',
    paid: false,
    deadline: '2025-07-05',
    postedDate: '2025-05-10',
    description: 'Join our creative team to design user interfaces for digital media applications. You will work on creating engaging and intuitive user experiences.',
    requirements: 'Design, HCI, or related field, Familiarity with design tools (Figma, Adobe XD), Basic understanding of UI/UX principles',
    responsibilities: 'Create wireframes and prototypes, Conduct user research, Design user interfaces, Collaborate with developers to implement designs',
    status: 'Open',
    applicationsCount: 20,
    industry: 'Digital Media',
    size: '100-500 employees',
    match: 75,
    interests: ['Digital Content', 'Streaming Technology', 'UI/UX Design', 'Mobile Development'],
    recommendations: [
      {
        studentName: 'Hana Mohamed',
        rating: 4.3,
        comment: 'Great exposure to the digital media industry. Worked on exciting UI/UX projects.'
      }
    ]
  },
  {
    id: 106,
    title: 'Cloud Engineering Intern',
    company: 'InnovateTech',
    companyId: 6,
    logo: 'https://cdn-icons-png.flaticon.com/512/4365/4365271.png',
    location: 'Cairo, Egypt (Hybrid)',
    duration: '4 months',
    paid: true,
    salary: '6000-8000 EGP/month',
    deadline: '2025-06-20',
    postedDate: '2025-05-03',
    description: 'Join our cloud engineering team to work on infrastructure and deployment solutions. You will gain experience with modern cloud platforms and DevOps practices.',
    requirements: 'Computer Science or related field, Basic understanding of cloud concepts, Familiarity with Linux systems',
    responsibilities: 'Assist in managing cloud infrastructure, Implement automation scripts, Help with deployment processes, Learn about scalable architecture',
    status: 'Open',
    applicationsCount: 10,
    industry: 'Technology Consulting',
    size: '500-1000 employees',
    match: 88,
    interests: ['Digital Transformation', 'Cloud Migration', 'Enterprise Architecture', 'Data Strategy'],
    recommendations: [
      {
        studentName: 'Amira Salah',
        rating: 4.6,
        comment: 'Excellent learning environment with exposure to multiple industries and technologies.'
      }
    ]
  },
  {
    id: 107,
    title: 'Marketing Research Intern',
    company: 'GlobalBrands',
    companyId: 7,
    logo: 'https://cdn-icons-png.flaticon.com/512/3938/3938074.png',
    location: 'Cairo, Egypt (Remote)',
    duration: '2 months',
    paid: false,
    deadline: '2025-07-15',
    postedDate: '2025-05-15',
    description: 'Join our marketing team to conduct market research, analyze consumer trends, and assist in developing marketing strategies. This internship provides valuable experience in the marketing field.',
    requirements: 'Marketing, Business, or related field, Strong analytical skills, Good communication abilities, Interest in consumer behavior',
    responsibilities: 'Conduct market research, Analyze customer data, Create reports on market trends, Assist in campaign planning',
    status: 'Open',
    applicationsCount: 5,
    industry: 'Marketing',
    size: '200-500 employees',
    match: 82,
    interests: ['Market Research', 'Digital Marketing', 'Consumer Behavior', 'Brand Management'],
    recommendations: [
      {
        studentName: 'Sarah Ahmed',
        rating: 4.4,
        comment: 'Great learning experience with exposure to real marketing challenges and supportive team.'
      }
    ]
  }
];

// Export as a named variable to fix ESLint warning
const internships = internshipsData;
export default internships;
